export const NAV_LINKS = [
  { label: 'Home',         path: '/' },
  { label: 'Shop',         path: '/shop' },
  { label: 'Our Story',    path: '/story' },
  { label: 'Philosophy',   path: '/philosophy' },
  { label: 'Transparency', path: '/transparency' },
  { label: 'Sevagram',     path: '/sevagram' },
  { label: 'Dashboard',    path: '/dashboard' },
  { label: 'Partners',     path: '/partners' },
  { label: 'Loyalty',      path: '/loyalty' },
  { label: 'Journal',      path: '/journal' },
  { label: 'Contact',      path: '/contact' },
];

export const PALETTE = {
  bg:      '#F4F8F9',
  surface: '#C1D7E2',
  mid:     '#AAC6D4',
  accent:  '#90B0BF',
  deep:    '#7C9CB1',
};

export const BRAND = {
  name: 'Shreesavaa',
  tagline: 'Radiance, distilled.',
  established: 'EST. MMXXV',
  email: 'seva@shreesavaa.com',
  sevaSutrasUrl:
    'https://customer-assets.emergentagent.com/wingman/c46b5479-fdab-4406-8c6a-b31561bab511/attachments/f6ed96a894df4d159192fc446b2c92fe_Shreesavaa_SoilTreeFruit_Complete.pdf',
  logoUrl:
    'https://customer-assets.emergentagent.com/wingman/c46b5479-fdab-4406-8c6a-b31561bab511/attachments/fce2e52ff0e84e038bd4d9977927fa8c_shreesavaa_white_transparent.png?v=2',
};

// Raw alchemical photography — the Atelier Mode visual library.
export const ATELIER_IMAGES = {
  kewraSteam:  'https://static.prod-images.emergentagent.com/jobs/c46b5479-fdab-4406-8c6a-b31561bab511/images/1483889d52fdb3a8859b260cab3522489d40b02e0fbaabc064f94d714428cc39.png',
  saffron:     'https://static.prod-images.emergentagent.com/jobs/c46b5479-fdab-4406-8c6a-b31561bab511/images/86d4aa18168958ccffe201e7d42d25326c9f7ff1877b5f0f44505695814a0866.png',
  tomatoSeeds: 'https://static.prod-images.emergentagent.com/jobs/c46b5479-fdab-4406-8c6a-b31561bab511/images/e018065ab6c1ad80c8d837be5034c9c06011eb6e0d08613fbd479452dbb0eba6.png',
  mortar:      'https://static.prod-images.emergentagent.com/jobs/c46b5479-fdab-4406-8c6a-b31561bab511/images/14959b55cdac567aefd64a61ef2317396a501a01a042d0a03e8b49f294af5511.png',
};
